export const GENERATOR_NAMES = {
  COURSE_OUTLINE: 'COURSE_OUTLINE',
  CONTENT_ASSISTANT: 'CONTENT_ASSISTANT',
  HEADLINE_ASSISTANT: 'HEADLINE_ASSISTANT',
  CONVERSATION_ASSISTANT: 'CONVERSATION_ASSISTANT',
} as const;

export const PLACEHOLDER_TEXT: { [key: string]: string } = {
  Site: 'Ex: Act like a marketer. Write a two-sentence value proposition for a website page about…',
  LandingPage:
    'Ex: Act like a marketer. Write a hook for a headline on a landing page for a course about…',
  EmailBroadcast:
    'Ex: Act like an email marketer. Write a three-paragraph email that entices the reader to…',
  EmailSequenceEmail:
    'Ex: Act like an email marketer. Write a three-paragraph email that entices the reader to…',
  MarketingEmailTemplate:
    'Ex: Act like an email marketer. Write a three-paragraph email that entices the reader to…',
  Product: 'Ex: Act like a marketer. Write a two-sentence instructor bio for a course about…',
  ThemeWizard: 'Ex: Public speaking for an event.',
  Default: 'Ex: Write a tagline for an icecream shop.',
};

// Top level keys where generated content is stored. It's used in useDeleteResultItem hook
export const GENERATOR_TOP_LEVEL_CONTENT_ATTRIBUTES = {
  COURSE_OUTLINE: ['categories'],
  CONTENT_ASSISTANT: [],
  HEADLINE_ASSISTANT: [],
  CONVERSATION_ASSISTANT: [],
} as const;

export const ERROR_TYPES = {
  ERROR: 'error',
  WARN: 'warn',
} as const;

export const ERROR_DISPLAY_STYLES = {
  INLINE: 'inline',
  FULLSCREEN: 'fullscreen',
} as const;

export const ERROR_MESSAGES = {
  DEFAULT: {
    message: 'Oops! There was an error during the generation process. Please try again!',
    type: ERROR_TYPES.ERROR,
    displayStyle: ERROR_DISPLAY_STYLES.INLINE,
  },
  FLAGGED_CONTENT: {
    message: 'Oops! Your entry has violated our safety guidelines. Please try again!',
    type: ERROR_TYPES.WARN,
    displayStyle: ERROR_DISPLAY_STYLES.INLINE,
  },
  TOO_MANY_REQUESTS: {
    message:
      'Oops! Your entry has exceeded the number of allowed requests. Please wait a moment and try again!',
    type: ERROR_TYPES.ERROR,
    displayStyle: ERROR_DISPLAY_STYLES.INLINE,
  },
  TOKEN_LIMIT: {
    message:
      'Oops! It seems our AI took a little detour. Please restart your chat or contact support if the issue persists.',
    type: ERROR_TYPES.ERROR,
    displayStyle: ERROR_DISPLAY_STYLES.FULLSCREEN,
  },
} as const;

export const MESSAGE_DATA_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
} as const;

export const MESSAGE_FRAGMENT_TYPES = {
  CODE: 'code',
  TEXT: 'text',
} as const;

export const CHAT_EVENT_TYPES = {
  STARTED: 'started',
  RESTARTED: 'restarted',
  TRANSFERRED_TO_SUPPORT: 'transferred_to_support',
  OPENED_FULLSCREEN: 'opened_fullscreen',
} as const;

export const OPEN_AI_CODE_WRAPPER = '```';

export const HIDE_INPUT_FORM_DISCLAIMER_COUNT_THRESHOLD = 6;

export const DEV_RESULT_STUB_ACTIVE: boolean = false;
export const DEV_OUTLINE_GENERATOR_RESULT_STUB = {
  categories: [
    {
      title: 'Getting Started Dancing 101',
      posts: [
        {
          title: 'Tools and Materials',
          body: 'Learn about the different tools and materials needed to start knitting, such as needles, yarn, and patterns.',
        },
        {
          title: 'Basic Stitches',
          body: 'Learn the basics of knitting, including the knit stitch, purl stitch, and how to cast on and off.',
        },
        {
          title: 'Gauge and Measurements',
          body: 'Understand how to measure gauge and take measurements to ensure your project turns out the way you want it to.',
        },
      ],
    },
    {
      title: 'Advanced Techniques',
      posts: [
        {
          title: 'Cables and Lace',
          body: 'Learn how to create intricate patterns with cables and lace, and how to read charts and patterns.',
        },
        {
          title: 'Colorwork',
          body: 'Discover the basics of colorwork and how to work with multiple colors in your knitting projects.',
        },
        {
          title: 'Finishing and Blocking',
          body: 'Learn how to finish your knitting projects, including seaming, weaving in ends, and blocking.',
        },
      ],
    },
  ],
  id: 'cmpl-aSDF1234',
  meta: {
    modelName: 'text-davinci-003',
    isFallbackModel: false,
  },
};
export const DEV_HEADLINE_ASSISTANT_GENERATOR_RESULT_STUB = {
  headlineContent: {
    headline: 'Learn to Dance with Confidence and Joy - Dancing 101',
    subheadline:
      'Tried the same old dance classes and still not getting the results you want? Dancing 101 provides exclusive content to help you learn to dance with confidence and joy. Sign up now to get started!',
  },
  id: 'cmpl-aSDF1234',
  meta: {
    modelName: 'text-davinci-003',
    isFallbackModel: false,
  },
};
export const DEV_CONVERSATION_ASSISTANT_RESULT_STUB = {
  content:
    'Sure! Here’s a CSS code snippet that will give you a red background:\n\n```css\nbody {\n  background-color: red;\n}\n```\n\nAnd here’s an HTML code snippet that will create a list of seasons:\n\n```html\n<ul>\n  <li>Spring</li>\n  <li>Summer</li>\n  <li>Fall</li>\n  <li>Winter</li>\n</ul>\n```\n\nFeel free to customize the CSS code to fit your specific needs, and let me know if there’s anything else I can assist you with!```html\n<li>\n</li>\n```',
  role: 'assistant',
  id: 'cmpl-aSDF1234',
  meta: {
    modelName: 'gpt-3.5-turbo',
    isFallbackModel: false,
  },
};

const DEV_CONTENT_ASSISTANT_RESULT_STUB = {
  content: 'Join us for an amazing live event!',
  id: 'cmpl-aSDF1234',
  meta: {
    modelName: 'text-davinci-003',
    isFallbackModel: false,
  },
};

export const DEV_RESULT_STUB = {
  COURSE_OUTLINE: DEV_OUTLINE_GENERATOR_RESULT_STUB,
  CONTENT_ASSISTANT: DEV_CONTENT_ASSISTANT_RESULT_STUB,
  HEADLINE_ASSISTANT: DEV_HEADLINE_ASSISTANT_GENERATOR_RESULT_STUB,
  CONVERSATION_ASSISTANT: DEV_CONVERSATION_ASSISTANT_RESULT_STUB,
};
